var map = {
	"./acrofan.png": "f26c",
	"./deepnatural.png": "2001",
	"./google.png": "f27e",
	"./hanbat.png": "96c0",
	"./hankyung.png": "2de5",
	"./kaist.png": "1715",
	"./kakao_enterprise.png": "4218",
	"./kyunghee.png": "e5b1",
	"./naver_ai_labs.png": "ca63",
	"./naver_clova.png": "010a",
	"./newyork.png": "69f6",
	"./riiid.png": "2fe8",
	"./scatter_lab.png": "b033",
	"./select_star.png": "ef87",
	"./seoul.png": "d68c",
	"./sogang.png": "d50f",
	"./upstage.png": "c75d",
	"./yonsei.png": "a153"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d8ff";